var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path-fill",
    d: "M11.5586 2.29171C10.9418 1.67075 10.2082 1.17801 9.40015 0.8419C8.59206 0.505792 7.72543 0.332962 6.85023 0.333375C3.16689 0.333375 0.191895 3.31671 0.191895 7.00004C0.191895 10.6834 3.16689 13.6667 6.85023 13.6667C9.95856 13.6667 12.5502 11.5417 13.2919 8.66671H11.5586C11.2153 9.6413 10.578 10.4854 9.73468 11.0824C8.89135 11.6795 7.88351 12.0001 6.85023 12C4.09189 12 1.85023 9.75837 1.85023 7.00004C1.85023 4.24171 4.09189 2.00004 6.85023 2.00004C8.23356 2.00004 9.46689 2.57504 10.3669 3.48337L7.68356 6.16671H13.5169V0.333375L11.5586 2.29171Z",
    fill: "#CE1111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.b1098656aadf40297a112d7f81468c3f.svg";
export { ForwardRef as ReactComponent };